import { render, staticRenderFns } from "./DistanceModalCreateLinkedArchives.vue?vue&type=template&id=1d7b2876&scoped=true&"
import script from "./DistanceModalCreateLinkedArchives.vue?vue&type=script&lang=js&"
export * from "./DistanceModalCreateLinkedArchives.vue?vue&type=script&lang=js&"
import style0 from "./DistanceModalCreateLinkedArchives.vue?vue&type=style&index=0&id=1d7b2876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b2876",
  null
  
)

export default component.exports